/* eslint-disable */
import Collapsible from '../plugins/collapsiblePlugin';

export default function initCollapsible() {

	const mainNav = document.querySelector('.main-nav');
	const header = document.querySelector('.header');
	const body = document.querySelector('body');

	document.querySelectorAll('.main-nav li').forEach((item) => {
		if (item.querySelector(':scope > ul') || item.querySelector(':scope > div')) {
			const openClose = new Collapsible({
				holder: item,
				opener: '> .main-nav__subnav-opener',
				altOpener: '> .main-nav__link',
				slide: '> .main-nav-slide',
				breakpoint: '1200px',
				header: header
			});
		}
	});



	const headerContentContainer = document.querySelector('header.header .header__content > .container');
	if (headerContentContainer) {
		const collapseTrigger = document.createElement('div');
		collapseTrigger.classList.add('collapse-trigger');
		collapseTrigger.addEventListener('mouseenter', () => {
			header.classList.remove('accessibility-hover-active');
			body.classList.remove('main-nav-hover-active');
		});
		headerContentContainer.appendChild(collapseTrigger);
	}

	mainNav.querySelectorAll('.main-nav__item').forEach((navItem) => {
		//if navItem has the child .main-nav-slide
		if (navItem.querySelector('.main-nav-slide')) {
			navItem.addEventListener('mouseenter', () => {
				header.classList.add('accessibility-hover-active');
				body.classList.add('main-nav-hover-active');
			});
		} else {
			navItem.addEventListener('mouseenter', () => {
				header.classList.remove('accessibility-hover-active');
				body.classList.remove('main-nav-hover-active');
			});
		}
	});

	mainNav.addEventListener('mouseleave', () => {
		header.classList.remove('accessibility-hover-active');
		body.classList.remove('main-nav-hover-active');
	});

}
